//Vertically aligned banner
var vCenterMaster = new function () {

    this.init = function () {

        // Template workaround: 
        // Moving bg color and bg image inline styles into the module parent, 
        // to get a bg image and color cover the whole column.
        $('.v-center-banner-on .normal').each(function () {

            var normal = $(this);
            var normalParent = $(normal).parent();
            var bgColor = $(normal).css("background-color");
            var bgImage = $(normal).css("background-image");

            $(normalParent).css("background-color", bgColor);
            $(normalParent).css("background-image", bgImage);

            //reset inline styles...
            $(normal).css("background-color", "");
            $(normal).css("background-image", "");

        });

    };

}


$(document).ready(function () {
    vCenterMaster.init();
})